"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVernacularBlockchain = exports.VernacularBlockchains = exports.Blockchains = void 0;
var Blockchains;
(function (Blockchains) {
    Blockchains["Binance"] = "Binance";
    Blockchains["Ethereum"] = "Ethereum";
    Blockchains["EthereumGoerli"] = "Goerli";
    Blockchains["EthereumRinkeby"] = "Rinkeby";
    Blockchains["BinanceTestnet"] = "BinanceTestnet";
    Blockchains["Iotex"] = "Iotex";
    Blockchains["Tron"] = "Tron";
    Blockchains["Harmony"] = "Harmony";
    Blockchains["Polygon"] = "Polygon";
    Blockchains["Avalanche"] = "Avalanche";
    Blockchains["BTTC"] = "BTTC";
    Blockchains["FTM"] = "FTM";
    Blockchains["OntologyTestnet"] = "OntologyTestnet";
    Blockchains["Ontology"] = "Ontology";
})(Blockchains = exports.Blockchains || (exports.Blockchains = {}));
exports.VernacularBlockchains = (_a = {},
    _a[Blockchains.Binance] = "BNB Chain",
    _a[Blockchains.BinanceTestnet] = "BNB Chain Testnet",
    _a[Blockchains.Ethereum] = "Ethereum",
    _a[Blockchains.EthereumRinkeby] = "Rinkeby",
    _a[Blockchains.Iotex] = "IoTeX",
    _a[Blockchains.Tron] = "Tron",
    _a[Blockchains.Harmony] = "Harmony",
    _a[Blockchains.Polygon] = "Polygon",
    _a[Blockchains.BTTC] = "BitTorrent",
    _a[Blockchains.Avalanche] = "Avalanche",
    _a[Blockchains.FTM] = "Fantom",
    _a[Blockchains.Ontology] = "Ontology EVM",
    _a[Blockchains.OntologyTestnet] = "Ontology EVM Testnet",
    _a);
var getVernacularBlockchain = function (blockchain) {
    var _a;
    return (_a = exports.VernacularBlockchains[blockchain]) !== null && _a !== void 0 ? _a : blockchain;
};
exports.getVernacularBlockchain = getVernacularBlockchain;
